/* global $ */
(function (scope) {
  "use strict";

  window.printUtilsFunctions = function () {};

  /**
	 * Generate a thumbnail url of the design
	 *
	 * @param {Design} design
	 * options = {
			solidity: false | true,
			size: {
				w: 100,
				h: 100
			},
			rotation: "0,0,0,1" | null,
			orientation: "side" | "backside" | "three_quarter"  (only if rotation is set to null),
		}
	 * @return {string}
	 */
  printUtilsFunctions.generateUrlImageDesign = function (design, options) {
    if (!design) {
      return;
    }

    options.solidity = options.solidity || false;
    options.size.w = options.size.w || 100;
    options.size.h = options.size.h || 100;
    options.rotation = options.rotation || null;
    options.orientation = options.orientation || "";

    var date = new Date();
    var url = URLS.render + "?uuid=" + design.model_uuid;

    url += "&width=" + options.size.w;
    url += "&height=" + options.size.h;

    url += "&quality=2";

    if (options.rotation != null) {
      url += "&rotq=" + options.rotation;
    } else {
      if (options.orientation == "side") {
        url += "&rotq=1,0,0,1";
      } else if (options.orientation == "backside") {
        url += "&rotq=0,0,0,1";
      } else if (options.orientation == "three_quarter") {
        url += "&rotq=.92387953251,0,0,0.38268343236";
      }
    }

    url += "&options=raytrace,ar=1";

    if (options.solidity) {
      var solidityValue = design.material.get_solidity_threshold(design.size);
      url +=
        ",seuilSoliditeBas=" +
        solidityValue * 0.7 +
        ",seuilSoliditeHaut=" +
        solidityValue * 1.2;
    } else if (options.material) {
      url += ",material=" + options.material;
    } else {
      url +=
        ",material=" +
        design.material.encoded(
          design.size,
          design.order.finish,
          design.order.painting,
          design,
          design.order.color
        )["material"];
    }

    url += "&nocache=" + date.getTime();

    return url;
  };

  //get the width and height of the scroll
  printUtilsFunctions.getBrowserScrollSize = function () {
    var css = {
      border: "none",
      height: "200px",
      margin: "0",
      padding: "0",
      width: "200px",
    };

    var inner = $("<div>").css($.extend({}, css));
    var outer = $("<div>")
      .css(
        $.extend(
          {
            left: "-1000px",
            overflow: "scroll",
            position: "absolute",
            top: "-1000px",
          },
          css
        )
      )
      .append(inner)
      .appendTo("body")
      .scrollLeft(1000)
      .scrollTop(1000);

    var scrollSize = {
      height: outer.offset().top - inner.offset().top || 0,
      width: outer.offset().left - inner.offset().left || 0,
    };

    outer.remove();
    return scrollSize;
  };
})((window.sculpteo = window.sculpteo || {}));
